import { sprig } from '@sprig-technologies/sprig-browser';
export const Sprig = sprig.configure({
  environmentId: 'qJSVQTcEf9',
});
